"use client";

import { ChevronUp } from "lucide-react";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

type Question = {
    question: string;
    answer: string;
};

const Questions = ({ questions }: { questions: Question[] }) => {
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

    const toggleExpand = (index: number) => {
        setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    return (
        <div className="flex flex-col gap-4">
            {questions.map((que, index) => (
                <motion.div 
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                    className="border border-gray-100 rounded-xl overflow-hidden bg-white hover:shadow-md transition-shadow duration-300"
                >
                    <button
                        className={`w-full text-left p-4 md:p-6 flex justify-between items-center gap-4 
                                  transition-colors duration-300 ${
                                      expandedIndex === index 
                                          ? 'bg-secondary/5 text-secondary' 
                                          : 'hover:bg-gray-50'
                                  }`}
                        onClick={() => toggleExpand(index)}
                        aria-expanded={expandedIndex === index}
                    >
                        <span className="font-semibold text-base md:text-lg">
                            {que.question}
                        </span>
                        <motion.div
                            animate={{ rotate: expandedIndex === index ? 180 : 0 }}
                            transition={{ duration: 0.2 }}
                        >
                            <ChevronUp className={`w-5 h-5 ${
                                expandedIndex === index ? 'text-secondary' : 'text-gray-400'
                            }`} />
                        </motion.div>
                    </button>

                    <AnimatePresence>
                        {expandedIndex === index && (
                            <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: "auto", opacity: 1 }}
                                exit={{ height: 0, opacity: 0 }}
                                transition={{ duration: 0.2 }}
                                className="overflow-hidden"
                            >
                                <div className="p-4 md:p-6 pt-0 text-gray-600">
                                    <p className="text-sm md:text-base leading-relaxed">
                                        {que.answer}
                                    </p>
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </motion.div>
            ))}
        </div>
    );
};

export default Questions;
